import { createSelector } from "reselect";
import { createAllPagesAllFacilitiesQuerySelector } from "../create_all_pages_all_facilities_query_selector";

export function createAllPagesAllFacilitiesContextSelector() {
  return createSelector(
    createAllPagesAllFacilitiesQuerySelector(),
    queries => queries
  );
}
